<template>
    <div class="LoaderComponent" :class="{ active : loading }"></div>
</template>

<script>
export default {
    name: 'LoaderComponent',
    props: {
        loading: { required: true, type: Boolean },
    },
};
</script>

<style lang="scss" scoped>
.LoaderComponent {
    --color: var(--q-primary);
    --size: 1em;
    --width: .2em;
    border: var(--width) solid transparent;
    border-top: var(--width) solid var(--color);
    border-radius: 50%;
    width: var(--size);
    height: var(--size);
    display: inline-block;
    animation: spin .8s linear infinite;
    opacity: 0;

    transition: opacity 0.3s linear 0.7s;

    &.active {
        opacity: 1;
    }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>